// Incremental number used to generate unique instance id to uniquely identify the component
let instance = 0;

/**
 * Switch input component.
 * Uses bootstrap css to render a switch.
 * 
 * @author Darrus Goh
 */
export default function SwitchInputComponent() {
    const UID = `switch${instance++}`;
    const DEFAULT_ONCHANGE = (checked) => { console.log(`Switch Input Component: ${checked}`) };

    const getId = (id) => {
        return id ? id : UID;
    };

    return {
        view: ({ attrs: { id, label, value, required, readonly, disabled, onchange = DEFAULT_ONCHANGE } }) => {
            return m('div.form-check.form-switch', { class: required && !value ? 'is-invalid-custom' : '' },
                m('input.form-check-input',
                    {
                        id: getId(id),
                        type: 'checkbox',
                        checked: value,
                        required,
                        readonly,
                        disabled,
                        onchange: (e) => { onchange(e.target.checked) }
                    }
                ),
                m('form-check-label', { for: getId(id) }, label)
            )
        }
    }
}